export default ({ unit, value }) =>
  `${value} ${unit.charAt(0).toUpperCase() + unit.slice(1)}${
    value > 1 ? 's' : ''
  }`;
